module.exports = __webpack_public_path__ + "static/media/title-banner-1.6a011094.png";